"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createParams(instanceUpdater, siteRevision) {
    var params = new self.URLSearchParams();
    if (instanceUpdater) {
        params.append('v', '2');
        params.append('instance', instanceUpdater.getInstance());
    }
    if (siteRevision) {
        params.append('siteRevision', siteRevision);
    }
    return params;
}
exports.createParams = createParams;
function withParams(url, params) {
    var rawParams = params.toString();
    var qs = rawParams === '' ? '' : "?" + rawParams;
    return "" + url + qs;
}
exports.withParams = withParams;
//# sourceMappingURL=params.js.map